function setTagalysConfiguration() {
  const tagalysConfig = window.__TAGALYS_CURRENCY_CONTEXT__

  if (!window.Tagalys || !tagalysConfig) return

  Tagalys.setConfiguration({
    api: {
      serverUrl: tagalysConfig.serverUrl || 'https://api-r3.tagalys.com',
    },
    locale: 'en-US',
    currency: {
      displayFormatter: '{{currencyLabel}}{{value}}',
      code: window.__TAGALYS_CURRENCY_CONTEXT__.isoCode,
      label: window.__TAGALYS_CURRENCY_CONTEXT__.symbol,
      fractionalDigits: 2,
      forceFractionalDigits: true,
    },
    analyticsStorageConsentProvided: function () {
      return true
    },
    track: true,
  })
}

function setPlatformConfigurationForTagalys() {
  const tagalysConfig = window.__TAGALYS_CURRENCY_CONTEXT__

  if (!window.Tagalys || !tagalysConfig) return

  Tagalys.setPlatformConfiguration({
    storefrontAPI: {
      myShopifyDomain: tagalysConfig.domain,
      accessToken: tagalysConfig.api,
    },
    metafields: {
      products: [
        {
          namespace: 'specs',
          key: 'case_diameter',
        },
        {
          namespace: 'specs',
          key: 'band_material',
        },
        {
          namespace: 'merchandise',
          key: 'variants',
        },
      ],
    },
    platform: 'Shopify',
    countryCode: Shopify.country,
    baseCountryCode: tagalysConfig.baseCountryCode || 'US',
    useStorefrontAPIForSecondaryMarkets: false,
    waitForStorefrontAPI: true,
  })
}

function onTagalysReady(callback) {
  if (window.Tagalys) {
    setTagalysConfiguration()
    setPlatformConfigurationForTagalys()
    callback()
  } else {
    window.addEventListener('DOMContentLoaded', function () {
      setTagalysConfiguration()
      setPlatformConfigurationForTagalys()
      callback()
    })
  }
}

// Elevar search event tracking (dl_view_search_results / dl_view_item_list)
// shared by the header search modal and the search-results page.
const pushToElevarDataLayer = (payload) => {
  window.ElevarDataLayer = window.ElevarDataLayer || []
  window.ElevarDataLayer.push(payload)

  if (window.Shopify.previewMode) {
    console.log('Push to Elevar DataLayer: ', payload)
  }
}

const pushSearchResultsDataLayerEvent = (query) => {
  if (!query) return
  pushToElevarDataLayer({
    event: 'dl_view_search_results',
    search_term: query,
  })
}

const buildSearchImpressionPayload = (product, position, listName) => {
  const variant = (product.variants && product.variants[0]) || {}
  return {
    id: variant.sku || product.id,
    product_id: product.id,
    variant_id: variant.id,
    name: product.title,
    brand: product.vendor,
    category: product.product_type,
    variant: variant.title,
    price: product.price,
    compare_at_price: product.compare_at_price,
    position,
    list: listName,
  }
}

const pushViewItemListDataLayerEvent = (products, listName, startPosition) => {
  if (!products || !products.length) return
  pushToElevarDataLayer({
    event: 'dl_view_item_list',
    ecommerce: {
      currencyCode: window.Shopify?.currency?.active,
      impressions: products.map((product, index) =>
        buildSearchImpressionPayload(
          product,
          (startPosition || 1) + index,
          listName
        )
      ),
    },
  })
}

// Fires dl_view_item_list once per batch of products whose cards cross
// into the viewport together, the first time each one appears — covers
// both "results just rendered" (cards already in view batch together on
// the first observer callback) and "user scrolled to reveal more
// products" (later callbacks batch whatever newly appeared since).
const createSearchImpressionTracker = (listName) => {
  let seenProductIds = {}
  let observer = null

  const ensureObserver = () => {
    if (observer) return observer
    observer = new IntersectionObserver(
      (entries) => {
        const newlyVisible = []

        entries.forEach((entry) => {
          if (!entry.isIntersecting) return
          observer.unobserve(entry.target)

          const productId = entry.target.dataset.elevarProductId
          const product = entry.target.__elevarProduct
          const position = entry.target.__elevarPosition
          if (!productId || !product || seenProductIds[productId]) return

          seenProductIds[productId] = true
          newlyVisible.push(
            buildSearchImpressionPayload(product, position, listName)
          )
        })

        if (newlyVisible.length) {
          pushToElevarDataLayer({
            event: 'dl_view_item_list',
            ecommerce: {
              currencyCode: window.Shopify?.currency?.active,
              impressions: newlyVisible,
            },
          })
        }
      },
      { threshold: 0.5 }
    )
    return observer
  }

  return {
    observeProductCard: (cardEl, product, position) => {
      if (!cardEl || !product || seenProductIds[product.id]) return
      cardEl.dataset.elevarProductId = product.id
      cardEl.__elevarProduct = product
      cardEl.__elevarPosition = position
      ensureObserver().observe(cardEl)
    },
    // Call when the search term genuinely changes, so a new search starts
    // with a clean slate — otherwise a product already seen under a
    // previous query (e.g. one letter changed, mostly the same results)
    // never fires a fresh impression for the new search.
    reset: () => {
      if (observer) observer.disconnect()
      seenProductIds = {}
    },
  }
}

// Scans the currently-rendered products for a widget and registers each
// card with the impression tracker. Called from a widget-level render
// callback (e.g. afterEveryRender), not a per-card one, since per-card
// callback props aren't reliably documented across Tagalys widgets.
const scanSearchResultsForImpressions = (products, rootEl, tracker) => {
  if (!products || !rootEl || !tracker) return
  products.forEach((product, index) => {
    const cardEl = rootEl.querySelector(
      `.product-card[data-product-id="${product.id}"]`
    )
    tracker.observeProductCard(cardEl, product, index + 1)
  })
}
